export default __webpack_public_path__ + "static/media/pin3.25e122e3.png";